export const DOCUMENT_TYPE_PRODUCT = 'product';
